import { render } from "./AreaConfig.vue?vue&type=template&id=4b651706"
import script from "./AreaConfig.vue?vue&type=script&lang=js"
export * from "./AreaConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__